import { Box, Drawer } from '@usealloy/component-library';
import styled, { css } from 'styled-components';
import { EditorContainerType } from 'flow/store/redux/constants';

export const StyledBox = styled(Box)`
  padding: var(--cl-space-4);
  overflow-x: auto;
`;

export const RuleLineContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-family: monospace;
  background: var(--cl-gray-100);
  top: 0;
  left: 0;
  width: calc(var(--cl-space-5) + 2px);
  height: 100%;
`;

export const RuleLineNumber = styled.pre<{
  active: boolean;
  isDraggable?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 1px;
  width: var(--cl-space-5);
  height: var(--cl-space-5);
  color: var(--cl-gray-500);
  text-align: center;
  border-radius: var(--cl-radius-1);
  font-size: var(--cl-font-size-1);
  transition: all 300ms ease;

  &:hover {
    color: var(--cl-gray-1100);
    background-color: var(--cl-gray-500);
    ${({ isDraggable }) => css`
      cursor: ${isDraggable ? 'grab' : 'pointer'};
    `}
  }

  ${({ active }) => active && css`
    color: var(--cl-gray-1100);
    background-color: var(--cl-gray-500);
  `}
`;

export const StyledDrawer = styled(Drawer)<{
  containerType: EditorContainerType;
  disableAnimation?: boolean;
}>`
  ${({ containerType }) => containerType === EditorContainerType.MODAL && css`
    left: var(--cl-space-5);
    right: var(--cl-space-5);
    bottom: var(--cl-space-5);
    border-radius: var(--cl-radius-3);
  `}
  
  ${({ disableAnimation }) => disableAnimation && css`
    transition: none !important;
  `}
`;
